import { version } from "./version";

export const environment = {
  version: version,
  production: true,
  errorReporting: true,
  config: "config.prod.json",
};
